import styled from "styled-components"
import { Card } from "rebass"
import theme from "../theme"

const StyledCard = styled(Card as any)`
  background-color: ${theme.colors.interactiveBackground};
  color: ${theme.colors.text};
  border-radius: 0px;
  box-shadow: none;
  @media screen and (max-width: 780px) {
    padding: 0.5rem;
  }
`

export default StyledCard
